import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import adf3137f67663deef77cb7d31eccd5956b from "./generated-ed21084f-ba43-4156-a74b-387af3d8b78e.json";

import a82a3e53a4282d42d0e20fcc27b159680b from "./generated-aff37edc-98e4-4014-94b0-59a8ffbc29b1.json";

import a045c3e972e09db92907cf3da26e8d819b from "./generated-1f173a6d-89a1-412b-a69f-cfab6cb337b3.json";

import a5e1caaecd676b821b65e1f7ee83081b1b from "./generated-e80e8aab-06bf-4a56-a2ea-1364812df404.json";

import ae3ad60cd31d6b1bf8cbc9acef9b219f8b from "./generated-dc0bb478-55ac-4448-a596-5e2433656aa6.json";

import ab06e2a0a4a8f8032087ebd4c4dd73449b from "./generated-d45f3b70-3039-4227-a27b-4dd32d843081.json";

import ad0c48f8e65d1a85da2243a0575ada8aeb from "./generated-611e893e-811d-424c-90c2-b21b1362dbd5.json";

import aca090a44dc69696e8ecba858744c63f4b from "./generated-a0bebd0b-16a2-402f-a499-d684a282ca36.json";

import a7e07ec3c51467a5af88bfbfd953c42dbb from "./generated-7913d95a-f813-4741-9eec-c3d2d7542d19.json";

import a8cc2cc0eeec56ddc3919341eff4f50f1b from "./generated-cd2faec9-8f8b-47d8-abad-3dc90a3853f1.json";

import a96bf21609c3a1a090deecffa0c22d0a1b from "./generated-777d37a0-ae06-4d17-a9b5-fb6e829918bb.json";

import ab0e2d8948749c24043d464c746a01667b from "./generated-7a446e34-800a-47ba-afac-faf5ebb99925.json";

import ab1c6caf6212651a265286d9ac16ce2a6b from "./generated-57b94aa7-7daa-4743-bcfd-93bfa1814ce8.json";

import af16d4f5b30179197f190a2b8eaa12788b from "./generated-963350e9-ea6a-4a4b-8d02-f848e8255676.json";

import afd926d36967c7ff68581184d7270ea6cb from "./generated-14ac8714-6221-49bd-ade1-7c6bfd5fdc71.json";

import a1a220ffee866db7c43e30fb4e0ef400fb from "./generated-7d889613-9883-4449-bca1-86b54de34cba.json";

import a16f44cb2ce9bcc7bb0b0ea49d212f05bb from "./generated-d8631eb3-35c9-4709-baf9-818cc2bd99b5.json";

import a4cc2c9fa2183edfcc6f40e4a4be68366b from "./generated-f231e70f-46ae-4166-aa77-3256eeae3013.json";

import a0626a8cf66f60a9ffd2f3252c78240eab from "./generated-6c0c2092-7bde-41b1-89a5-80622ce22653.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(adf3137f67663deef77cb7d31eccd5956b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a82a3e53a4282d42d0e20fcc27b159680b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a045c3e972e09db92907cf3da26e8d819b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a5e1caaecd676b821b65e1f7ee83081b1b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ae3ad60cd31d6b1bf8cbc9acef9b219f8b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ab06e2a0a4a8f8032087ebd4c4dd73449b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad0c48f8e65d1a85da2243a0575ada8aeb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aca090a44dc69696e8ecba858744c63f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a7e07ec3c51467a5af88bfbfd953c42dbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a8cc2cc0eeec56ddc3919341eff4f50f1b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a96bf21609c3a1a090deecffa0c22d0a1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ab0e2d8948749c24043d464c746a01667b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ab1c6caf6212651a265286d9ac16ce2a6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(af16d4f5b30179197f190a2b8eaa12788b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(afd926d36967c7ff68581184d7270ea6cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a1a220ffee866db7c43e30fb4e0ef400fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a16f44cb2ce9bcc7bb0b0ea49d212f05bb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a4cc2c9fa2183edfcc6f40e4a4be68366b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0626a8cf66f60a9ffd2f3252c78240eab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a16f44cb2ce9bcc7bb0b0ea49d212f05bb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */